/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceConfigurationItemDto } from "./DeviceConfigurationItemDto";
import {
    DeviceConfigurationItemDtoFromJSON,
    DeviceConfigurationItemDtoFromJSONTyped,
    DeviceConfigurationItemDtoToJSON,
} from "./DeviceConfigurationItemDto";
import type { DeviceConfigurationSchemaDto } from "./DeviceConfigurationSchemaDto";
import {
    DeviceConfigurationSchemaDtoFromJSON,
    DeviceConfigurationSchemaDtoFromJSONTyped,
    DeviceConfigurationSchemaDtoToJSON,
} from "./DeviceConfigurationSchemaDto";

/**
 *
 * @export
 * @interface DeviceConfigurationAndSchema
 */
export interface DeviceConfigurationAndSchema {
    /**
     *
     * @type {DeviceConfigurationItemDto}
     * @memberof DeviceConfigurationAndSchema
     */
    config?: DeviceConfigurationItemDto;
    /**
     *
     * @type {DeviceConfigurationSchemaDto}
     * @memberof DeviceConfigurationAndSchema
     */
    schema?: DeviceConfigurationSchemaDto;
}

/**
 * Check if a given object implements the DeviceConfigurationAndSchema interface.
 */
export function instanceOfDeviceConfigurationAndSchema(
    value: object,
): value is DeviceConfigurationAndSchema {
    return true;
}

export function DeviceConfigurationAndSchemaFromJSON(
    json: any,
): DeviceConfigurationAndSchema {
    return DeviceConfigurationAndSchemaFromJSONTyped(json, false);
}

export function DeviceConfigurationAndSchemaFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConfigurationAndSchema {
    if (json == null) {
        return json;
    }
    return {
        config:
            json["config"] == null
                ? undefined
                : DeviceConfigurationItemDtoFromJSON(json["config"]),
        schema:
            json["schema"] == null
                ? undefined
                : DeviceConfigurationSchemaDtoFromJSON(json["schema"]),
    };
}

export function DeviceConfigurationAndSchemaToJSON(
    value?: DeviceConfigurationAndSchema | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        config: DeviceConfigurationItemDtoToJSON(value["config"]),
        schema: DeviceConfigurationSchemaDtoToJSON(value["schema"]),
    };
}
